import React, { useEffect, useState } from "react";

import { Button, Table, Modal, Select, Row } from "@shared/ui";

import styles from "./styles.module.scss";
import { ColumnsType } from "antd/es/table";
import {
  ArrowLeftOutlined,
  CopyTwoTone,
  DownloadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Col, Divider, Input, Space, Image, Typography, Spin } from "antd";

import { BrandForm } from "@entities/brand";

import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { useGetReports } from "@entities/reports/lib/hooks/useGetReports";
import { useCreateReport } from "@entities/reports/lib/hooks/useCreateReport";
import { IGetReport, ReportMedia } from "@shared/lib/types/reports";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "@app/constants";
import { ReportForm } from "@entities/reports/ui/ReportForm";
import { format, formatDate } from "date-fns";
import { useAddMediaReport } from "@entities/reports/lib/hooks/useAddMediaReport";
import { useGetReportDetail } from "@entities/reports/lib/hooks/useGetReportDetail";
import { AddMediaForm } from "@entities/reports/ui/AddMediaForm";
import { ToastService } from "@shared/lib/services";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";
import { formatData } from "@shared/lib/utils/formatData";
import { useDownloadReports } from "@entities/downloads/lib/hooks/useDownloadReports";
import { useGetReportFacets } from "@entities/reports/lib/hooks/useGetReportFacets";
import SelectFilter from "@shared/ui/filters/SelectFilter";
import { platform } from "process";
import { ReportPerformanceMetrics } from "@features/ReportPerformanceMetrics";
import { useGetReportMedia } from "@entities/reports/lib/hooks/useGeReportMedia";
import { ReportMediaCard } from "@features/ReportMediaCard/ReportMediaCard";
import { ReportMediaPerformance } from "@features/ReportMediaPerformance";
import { RepoerMeidaCommentAnalysis } from "@features/ReportMediaCommentAnalysis";
import CommentAnalysis from "@entities/thirdPartyDiscovery/ui/CommentAnalysis";
import { TopMediaComments } from "@features/TopMediaComments";

const { Search } = Input;
const { Title, Text } = Typography;

export function ReportMediaPage() {
  const { reportId, mediaId } = useParams();

  const {
    report,
    isError,
    isFetching: isFetchingReport,
  } = useGetReportDetail(reportId || "", false);

  const {
    reportMedia,
    isError: isErrorMedia,
    isFetching: isFetchingReportMedia,
  } = useGetReportMedia(reportId || "", mediaId || "");

  const navigate = useNavigate();

  if (isFetchingReportMedia) {
    return (
      <Row justify={"center"} style={{ margin: "200px 0" }}>
        <Spin />
      </Row>
    );
  }

  if (isError || isErrorMedia || !reportMedia) {
    return (
      <Row justify={"center"} style={{ margin: "200px 0" }}>
        Invalid Id
      </Row>
    );
  }

  return (
    <div>
      <div className={styles.card}>
        <div className={styles.recordLabel} style={{ padding: "10px 0" }}>
          <Button
            icon={<ArrowLeftOutlined />}
            style={{ margin: 0 }}
            onClick={() =>
              navigate(
                ROUTES.REPORT_DETAIL.replace(":reportId", reportId || "")
              )
            }
          />
        </div>
        {/* <Divider style={{ margin: 0 }} /> */}

        <div className={styles.flex} style={{ marginBottom: 20 }}>
          <div>{getPlatformIcon(reportMedia?.platform, styles.icon)}</div>
          <div>
            <Title level={2}>
              {reportMedia?.platform} {reportMedia?.mediaType}
            </Title>
            <Text type="secondary">
              Posted{" "}
              {reportMedia?.postedOn
                ? format(
                    new Date(reportMedia?.postedOn),
                    "MMM dd, yyyy h:mm aa"
                  )
                : ""}
            </Text>
          </div>
        </div>
        <ReportMediaCard report={reportMedia} />
        <ReportMediaPerformance media={reportMedia} />
        <Divider />
        <RepoerMeidaCommentAnalysis media={reportMedia} />
        <Divider />
        <TopMediaComments media={reportMedia} />
        <div style={{ height: "100px" }}></div>

        {/* <Table
          dataSource={report?.data}
          columns={columns}
          loading={isFetchingReport}
          rowKey="_id"
          style={{ marginTop: "20px" }}
          scroll={{ x: 1000 }}
        /> */}
      </div>
    </div>
  );
}
